import React, { useState, useEffect, useRef } from "react";
import BookDataService from "../services/BookService";
import "./styles/BookList.css";
import BookCard from "./BookCard";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import {
  MdFormatListBulleted,
  MdEdit,
  MdOutlineMenuBook,
} from "react-icons/md";
import DropDownSelector from "./micro_components/DropDownSelector";
import CategoryDataService from "../services/CategoryService";
import DomainService from "../services/DomainService";
// VERSIONING
// import VersionService from "../services/VersionService";
// import { version } from "../version";
// import VersionModal from "./micro_components/VersionModal";

//loader
import { css } from "@emotion/react";
import SyncLoader from "react-spinners/SyncLoader";

// import { useLocation } from "react-router-dom";

import { ReactComponent as Arrow } from "../assets/arrow.svg";
import BookListPagination from "./BookListPagination";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useLocation } from "react-router-dom";
const override = css`
  position: abolute;
  left: vh;
`;

const loadingColor = "#8C9BD8";

const BooksList = () => {
  // Set what books are showing as an array
  const [books, setBooks] = useState([]);

  // const [relations, setRelations] = useState([]);
  const [categories, setCategories] = useState([]);
  const [catNames, setCatNames] = useState();
  const [selectedCatFilter, selectCatFilter] = useState("All Categories");

  // const [domains, setDomains] = useState([]);
  const [selectedDomain, setSelectedDomain] = useState("All Domains");
  // const [selectedDomainID, setSelectedDomainID] = useState();
  const [domainNames, setDomainNames] = useState([]);
  // const [filteredBookIds, setFilteredBookIds] = useState([]);
  //set title of search bar
  const [searchTitle, setSearchTitle] = useState("");
  let [loading, setLoading] = useState(true);

  const [allBooks, setAllBooks] = useState();

  // const [versionModalOpen, setVersionModalOpen] = useState(false);
  // const [newVersion, setNewVersion] = useState("0.0.0");
  const [cardSize, setCardSize] = useState("large");
  const [sortBy, setSortBy] = useState("id");
  const [sortDir, setSortDir] = useState("descending");

  const [recentBooks, setRecentBooks] = useState([]);

  const titleSearchRef = useRef();

  // new state for filtered books (includes all filters)
  const [filteredBooks, setFilteredBooks] = useState([]);

  // PAGINATION
  const BOOKS_PER_PAGE = 30;
  const [page, setPage] = useState(0);
  const [firstBookIndexOnPage, setFirstBookindexOnPage] = useState(0);

  //on initialization, retreive all books
  useEffect(() => {
    if (books.length < 1) {
      retrieveData();
    } else {
      setLoading(false);
    }
  }, [books]);

  // On load, check for new version
  useEffect(() => {
    // VersionService.getCurrent()
    //   .then((response) => {
    //     if (version === response.data.id) {
    //     } else {
    //       setVersionModalOpen(true);
    //       setNewVersion(response.data.id);
    //     }
    //   })

    // hijacking this useEffect to initialize recentBooks
    setRecentBooks(JSON.parse(localStorage.getItem("recentbooks")));
  }, []);

  //called when search bar is typed into, changed value of variable searchTitle

  const onChangeSearchTitle = (e) => {
    setSearchTitle(e.target.value);
  };

  useEffect(() => {
    if (allBooks) {
      let lastDomain =
        localStorage.getItem("lastDomainFilter") || "All Domains";
      handleDomainDrop(lastDomain);
    }
  }, [allBooks]);

  //Get all data: categories, books, relations
  const retrieveData = () => {
    BookDataService.getAllMinimal()
      .then((response) => {
        // setFilteredBooks(response.data);
        sortBooks("id", "descending", response.data); // third argument is used only in this call
        setBooks(response.data);
        setAllBooks(response.data);
        handleDomainDrop(
          localStorage.getItem("lastDomainFilter") || "All Domains"
        );
        // setCategoryBookIds(response.data.map((book) => book.id));
      })
      .catch((e) => {});

    CategoryDataService.getAll()
      .then((response) => {
        setCategories(response.data);
        // setCatList();
      })
      .catch((e) => {});

    DomainService.getAll()
      .then((response) => {
        // setDomains(response.data);
        let tempDN = [{ name: "All Domains" }];
        response.data.forEach((domain) => {
          tempDN.push({ name: domain.name, id: domain.id });
        });

        setDomainNames(tempDN);
      })
      .catch((e) => {});
  };

  //after categories change, set the names
  useEffect(() => {
    const names = [];
    names.push({ name: "All Categories" });
    for (let i = 0; i < categories.length; i++) {
      names.push({ name: categories[i].name });
    }
    setCatNames(names);
  }, [categories]);

  //Find Books by title = search bar
  const findByTitle = (string = "") => {
    let booksFilteredByTitle = allBooks.slice();

    if (string !== "") {
      booksFilteredByTitle = booksFilteredByTitle.filter((b) =>
        b.title.toLowerCase().includes(string.toLowerCase())
      );
    }

    // if applicable, also filter by category and domain
    if (selectedCatFilter !== "All Categories") {
      const chosenCategory = categories.find(
        (c) => c.name === selectedCatFilter
      );
      booksFilteredByTitle = booksFilteredByTitle.filter((b) =>
        Boolean(b.categoryIds.includes(chosenCategory.id))
      );
    }
    if (selectedDomain !== "All Domains") {
      booksFilteredByTitle = booksFilteredByTitle.filter((b) => {
        // eslint-disable-next-line eqeqeq
        return b.domain_id == selectedDomain;
      });
    }

    setFilteredBooks(booksFilteredByTitle);
  };

  const handleCatDrop = (cat) => {
    let booksFilteredByCategory = allBooks.slice();

    if (cat === "All Categories") {
      selectCatFilter("All Categories");
    } else {
      selectCatFilter(cat);
      const chosenCategory = categories.find((c) => c.name === cat);

      // find books that are a member of the chosen category
      booksFilteredByCategory = booksFilteredByCategory.filter((book) =>
        Boolean(book.categoryIds.includes(chosenCategory.id))
      );
    }

    // if applicable, also filter by domain and title
    if (selectedDomain !== "All Domains") {
      booksFilteredByCategory = booksFilteredByCategory.filter(
        (b) => b.domain_id === parseInt(selectedDomain)
      );
    }
    if (searchTitle !== "") {
      booksFilteredByCategory = booksFilteredByCategory.filter((b) =>
        b.title.toLowerCase().includes(searchTitle.toLowerCase())
      );
    }

    setFilteredBooks(booksFilteredByCategory);
  };

  const handleDomainDrop = (dom) => {
    let booksFilteredByDomain = allBooks.slice();
    localStorage.setItem("lastDomainFilter", dom);

    if (dom === "All Domains") {
      setSelectedDomain("All Domains");
    } else {
      setSelectedDomain(dom);
      booksFilteredByDomain = booksFilteredByDomain.filter(
        (b) => b.domain_id === parseInt(dom)
      );
    }

    // if applicable, also filter by domain and title
    if (selectedCatFilter !== "All Categories") {
      booksFilteredByDomain = booksFilteredByDomain.filter(
        (b) => b.domain_id === parseInt(selectedDomain)
      );
    }
    if (searchTitle !== "") {
      booksFilteredByDomain = booksFilteredByDomain.filter((b) =>
        b.title.toLowerCase().includes(searchTitle.toLowerCase())
      );
    }

    setFilteredBooks(booksFilteredByDomain);
  };

  // const handleVersionModalClose = () => {
  //   setVersionModalOpen(false);
  // };

  function sortBooks(criterion, direction, books = filteredBooks) {
    let temp = books;

    if (direction === "ascending") {
      temp.sort((a, b) => {
        if (a[criterion] < b[criterion]) return -1;
        if (a[criterion] > b[criterion]) return 1;
        return 0;
      });
    } else {
      temp.sort((a, b) => {
        if (a[criterion] < b[criterion]) return 1;
        if (a[criterion] > b[criterion]) return -1;
        return 0;
      });
    }

    setSortBy(criterion);
    setSortDir(direction);

    setFilteredBooks(temp);
  }

  function pageBack() {
    const newPage = Math.max(0, page - 1);
    setPage(newPage);
    setFirstBookindexOnPage(newPage * BOOKS_PER_PAGE);
  }

  function pageForward() {
    const newPage = Math.ceil(
      Math.min(filteredBooks.length / BOOKS_PER_PAGE - 1, page + 1)
    );
    setPage(newPage);
    setFirstBookindexOnPage(newPage * BOOKS_PER_PAGE);
  }

  function goToPage(dest) {
    setPage(dest);
    setFirstBookindexOnPage(dest * BOOKS_PER_PAGE);
  }

  return (
    <>
      {/* {versionModalOpen && (
        <VersionModal isOpen={versionModalOpen} onClose={handleVersionModalClose} newVersion={newVersion} />
      )} */}
      {loading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "40vh",
          }}
        >
          <SyncLoader
            color={loadingColor}
            loading={loading}
            css={override}
            style={{ marginLeft: "auto auto" }}
          />
        </div>
      ) : (
        <div className="book-list-container">
          <div className="book-list-filter-bar">
            {/* Search bar and Search button */}
            <div className="input-group" style={{ width: "fit-content" }}>
              {/* Search text field */}
              <input
                ref={titleSearchRef}
                type="text"
                className="book-search-bar form-control"
                placeholder="Search by title"
                value={searchTitle}
                onChange={onChangeSearchTitle}
                onKeyDown={(e) => {
                  if (e.key === "Enter") findByTitle(searchTitle);
                }}
              />
              <button
                type="button"
                className="btn bg-transparent clear-icon"
                style={{
                  position: "relative",
                  left: "-45px",
                  zIndex: "3",
                  color: "gray",
                }}
              >
                <ClearIcon
                  className={"clear-icon"}
                  onClick={() => {
                    setSearchTitle("");
                    findByTitle();
                    titleSearchRef.current.focus();
                  }}
                />
              </button>
              <div className="input-group-append">
                {/* Search button */}
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => findByTitle(searchTitle)}
                  style={{ position: "relative", left: "-45px", zIndex: "3" }}
                >
                  <SearchIcon />
                </button>
              </div>
            </div>
            {/* Add to search query and only give back the ones with the correct category relation */}
            <div className="cat-filter">
              <DropDownSelector
                data={domainNames}
                className="form-control"
                value={selectedDomain || ""}
                placeholder="Domain"
                onChange={handleDomainDrop}
              />
            </div>
            <div className="cat-filter">
              {catNames && (
                <DropDownSelector
                  data={catNames}
                  className="form-control"
                  value={selectedCatFilter || ""}
                  placeholder="Category"
                  onChange={handleCatDrop}
                />
              )}
            </div>

            {/* <div className=" dom-filter">
        <div>Filter by Domain</div>
      </div> */}
            <div className="book-list-view-mode-controls">
              <span style={{ fontWeight: "bold" }}>Card size: </span>
              <button
                className={`${cardSize === "large" ? "selected" : ""}`}
                onClick={() => setCardSize("large")}
              >
                Large
              </button>
              <button
                className={`${cardSize === "small" ? "selected" : ""}`}
                onClick={() => setCardSize("small")}
              >
                Small
              </button>
            </div>
            <div className="book-list-view-mode-controls">
              <span style={{ fontWeight: "bold" }}>Sort by </span>
              <button
                className={`${sortBy === "id" ? "selected" : ""}`}
                onClick={() => sortBooks("id", sortDir)}
              >
                ID
              </button>
              <button
                className={`${sortBy === "title" ? "selected" : ""}`}
                onClick={() => sortBooks("title", sortDir)}
              >
                Title
              </button>
              <button
                id="arrow"
                onClick={() =>
                  sortBooks(
                    sortBy,
                    sortDir === "ascending" ? "descending" : "ascending"
                  )
                }
              >
                <div
                  style={{
                    transform:
                      sortDir === "ascending"
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                  }}
                >
                  <Arrow />
                </div>
              </button>
            </div>
          </div>
          <p style={{ margin: "1rem", fontSize: "1.25rem", fontWeight: "500" }}>
            Recently opened books
          </p>
          <div className="book-list__recent-books-wrapper">
            {recentBooks?.length > 0 ? (
              recentBooks.map((b) => (
                <React.Fragment key={b.id}>
                  <RecentBookMiniCard book={b} />
                </React.Fragment>
              ))
            ) : (
              <p style={{ margin: "2rem" }}>No recent books!</p>
            )}
          </div>
          {filteredBooks.length > 0 ? (
            <>
              <div style={{ paddingLeft: "1rem" }}>
                <h1 style={{ fontWeight: "bolder" }}>All Books</h1>
              </div>
              <BookListPagination
                pageForward={pageForward}
                pageBack={pageBack}
                maxPages={Math.ceil(filteredBooks.length / BOOKS_PER_PAGE)}
                page={page}
                goToPage={goToPage}
              />
            </>
          ) : null}
          {filteredBooks.length > 0 ? (
            <div className="book-list">
              {filteredBooks
                .slice(
                  firstBookIndexOnPage,
                  firstBookIndexOnPage + BOOKS_PER_PAGE
                )
                .map((book) => (
                  <React.Fragment key={book.id}>
                    <BookCard book={book} size={cardSize} />
                  </React.Fragment>
                ))}
            </div>
          ) : (
            <div style={{ width: "100%" }}>
              <h3>
                <i>There are no books that meet these criteria.</i>
              </h3>
            </div>
          )}
          {filteredBooks.length > 0 ? (
            <BookListPagination
              pageForward={pageForward}
              pageBack={pageBack}
              maxPages={Math.ceil(filteredBooks.length / BOOKS_PER_PAGE)}
              page={page}
              goToPage={goToPage}
            />
          ) : null}
        </div>
      )}
    </>
  );
};

export default BooksList;

function RecentBookMiniCard({ book: { title, id, image } }) {
  const history = useHistory();
  const location = useLocation();

  const goToBookDetails = () => {
    updateRecentBooks();
    const queryParams = new URLSearchParams(location.search);
    queryParams.set("tab", "details");
    history.push({
      pathname: `/books/${id}`,
      search: queryParams.toString(),
    });
  };

  const goToDevelopBook = () => {
    updateRecentBooks();
    const queryParams = new URLSearchParams(location.search);
    queryParams.set("tab", "develop");
    history.push({
      pathname: `/books/${id}`,
      search: queryParams.toString(),
    });
  };

  const goToResources = () => {
    updateRecentBooks();
    const queryParams = new URLSearchParams(location.search);
    queryParams.set("tab", "resources");
    history.push({
      pathname: `/books/${id}`,
      search: queryParams.toString(),
    });
  };

  // update the recently edited books in localStorage
  // (this fires when going into any of the three modes
  // ("details", "develop", "resources"))
  function updateRecentBooks() {
    let temp = JSON.parse(localStorage.getItem("recentbooks"));

    // if (no recent books) {...} else {...}
    if (temp === null) {
      temp = [{ index: 0, id, title, image }];
      localStorage.setItem("recentbooks", JSON.stringify(temp));
    } else {
      let bookAlreadyInArray = temp.find((b) => b.id === id);

      // this book is already in recentbooks
      if (bookAlreadyInArray) {
        temp.splice(bookAlreadyInArray.index, 1);
      }
      temp.unshift({ index: 0, id, title, image: image });
    }

    // re-assign the indices
    if (temp?.length > 1) {
      temp.forEach((el, i) => (el.index = i));
      if (temp?.length > 10) {
        temp.pop();
      }
    }

    // finally, update localStorage
    localStorage.setItem("recentbooks", JSON.stringify(temp));
  }

  return (
    <div className="recent-book-mini-card">
      <div style={{ display: "flex", flex: "1 0" }}>
        <img src={image} alt={`${title}_cover`} />
        <p style={{ fontWeight: 600, lineHeight: "1.2rem" }}>{title}</p>
      </div>
      <div className="recent-book__button-wrapper">
        <button
          className="recent-card-button"
          id="details"
          onClick={goToBookDetails}
        >
          <MdFormatListBulleted />
        </button>
        <button
          className="recent-card-button"
          id="develop"
          onClick={goToDevelopBook}
        >
          <MdEdit />
        </button>
        <button
          className="recent-card-button"
          id="resources"
          onClick={goToResources}
        >
          <MdOutlineMenuBook />
        </button>
      </div>
    </div>
  );
}
